<template>
  <WdsStack direction-row gap-sm align-center>
    <WdsSelect
      v-model="model"
      v-model:search="searchStr"
      class="tw-w-full"
      can-deselect
      multi-select
      :data-test="`filter-skills`"
      :placeholder="$t('Search skills')"
      :label="$t('Required skills')"
      :list="skills"
      persist-input-on-select
      name="workflow-user-group-select"
      :load-more-distance="10"
      custom-search
      searchable
      labels-primary
      @load-more="loadMoreSkills"
    ></WdsSelect>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef, ref } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { $t } from '@/composables/translation'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'
import { graphql } from '@/gql'
import { flat } from '@/utils/tools'

const { meta } = defineProps<{ meta: FilterMetaDataProp }>()

const searchStr = ref('')

const model: ModelRef<boolean | null> = defineModel({
  default: () => null,
})

const { result, loading, fetchMore } = useQuery(
  graphql(`
    query SkillsFilterQuery($search: String, $first: Int!, $page: Int) {
      skills(search: $search, first: $first, page: $page) {
        paginatorInfo {
          total
        }
        data {
          id
          value: name
          label: name
        }
      }
    }
  `),
  () => ({
    search: searchStr.value,
    first: 50,
    page: 1,
  }),
  {
    clientId: 'publicApiCustomFields',
  },
)

const loadMoreSkills = () => {
  if (loading.value) return
  const { hasMorePages, currentPage } = flat(result.value ?? {}) ?? {}
  if (!hasMorePages) return
  fetchMore({
    variables: {
      page: currentPage + 1,
    },
  })
}

const skills = computed(() => result.value?.skills.data ?? [])
</script>
